import { useRoutes, Outlet } from 'react-router-dom';
// import Home from '../Home';
import Home from '../Home';
import Search from '../Search';
import AddBatch from '../AddBatch';
import ListBatch from '../ListBatch';
import DetailBatch from '../DetailBatch';
import HomeComponentMobile from '../HomeComponentMobile';
import AdvanceSearchComponent from '../AdvanceSearch';
import UpcomingCourcesComponent from '../UpcomingCources';
import AddBatchMobile from '../AddBatchMobile'; 
const routes = [
  {
    path: '/',
    element: <Home />,
    showHeader: true,
  },
  {
    path: '/search',
    element: <AdvanceSearchComponent />,
    showHeader: true,
  },
  {
    path: '/upcoming-courses',
    element: <UpcomingCourcesComponent />,
    showHeader: true,
  },
  {
    path: '/search/:course',
    element: <Search />,
    showHeader: true,
  },
  {
    path: '/add-batch/new',
    element: <AddBatch />,
    showHeader: true,
  },
  {
    path: '/add-batch-client/new/edit', 
    element: <AddBatchMobile />,         
    showHeader: true,                    
    },
  {
    path: '/batch-list/:course/:date',
    element: <ListBatch />,
    showHeader: true,
  },
  {
    path: '/batch-list/:course/:date/:id',
    element: <DetailBatch />,
    showHeader: true,
  },
];

export const RouterApp = () => {
  return useRoutes(routes);
};

export const RoutesList = routes;
